import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { Alert, Box } from '@mui/material';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';

import { Block } from 'components/page';
import { DreFormTitle } from 'pages/financeiro/dre/components/atoms/DreFormTitle';
import { useQueryGrupos } from 'pages/financeiro/dre/hooks';
import { getErrorMessage } from 'util/error';

/**
 * Foca o grupo/subgrupo selecionado a partir da árvore.
 */
const focusElement = (value: string) => {
    const element = document.getElementById(value);

    if (element) {
        const headerOffset = 16;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }
};

export function DreFormMenu() {
    const { isFetching, isSuccess, data, isError, error } = useQueryGrupos();

    return (
        <Block
            sx={{
                flex: 2,
                top: 16,
                margin: 0,
                padding: 0,
                minWidth: 240,
                display: 'flex',
                flexDirection: 'column',
                position: { xs: 'static', md: 'sticky' },
            }}
        >
            <DreFormTitle label="Grupos" />

            {isFetching && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, padding: 1 }}>
                    {Array.from({ length: 5 }).map((_, index) => (
                        <Box key={index} className="pulse" sx={{ height: 30, backgroundColor: 'grey.200', borderRadius: 1 }} />
                    ))}
                </Box>
            )}

            {isError && (
                <Alert sx={{ m: 1 }} severity="error">
                    {getErrorMessage(error) || 'Falha ao carregar os grupos'}
                </Alert>
            )}

            {isSuccess && !isFetching && (
                <SimpleTreeView
                    slots={{ collapseIcon: ExpandMoreOutlinedIcon, expandIcon: ChevronRightOutlinedIcon }}
                    onItemSelectionToggle={(event, value) => focusElement(value)}
                    sx={{
                        'padding': 1,
                        '.MuiTreeItem-content': {
                            'p': 0.5,

                            '.MuiTreeItem-iconContainer svg': {
                                fontSize: '1.6rem',
                            },

                            '.MuiTreeItem-label': {
                                fontSize: '1.05rem',
                            },

                            '&:hover': {
                                backgroundColor: 'grey.100',
                                borderRadius: 1,
                            },

                            '&.Mui-selected': {
                                backgroundColor: 'grey.300',
                                borderRadius: 1,
                            },
                        },
                    }}
                >
                    {data.map((menu) => {
                        return (
                            <TreeItem
                                key={menu.idDreMercadologicaTipoGrupoExibicao}
                                label={menu.dsDreMercadologicaTipoGrupoExibicao}
                                itemId={menu.idDreMercadologicaTipoGrupoExibicao.toString()}
                                sx={{
                                    '& > .MuiTreeItem-content': {
                                        'color': 'primary.main',

                                        '.MuiTreeItem-label': {
                                            fontWeight: 700,
                                        },
                                    },
                                }}
                            >
                                {menu.gruposExibicao.map((submenu) => {
                                    return (
                                        <TreeItem
                                            key={submenu.idDreMercadologicaGrupoExibicao}
                                            label={submenu.dsDreMercadologicaGrupoExibicao}
                                            itemId={`${menu.idDreMercadologicaTipoGrupoExibicao}_${submenu.idDreMercadologicaGrupoExibicao}`}
                                        />
                                    );
                                })}
                            </TreeItem>
                        );
                    })}
                </SimpleTreeView>
            )}
        </Block>
    );
}
